<div class="shipment-stepper">
  <puro-typography class="shipment-stepper__title" variant="h1" component="h1">
    {{ 'createShipment.pageTitle' | translate }}
  </puro-typography>

  <nav
    class="shipment-stepper__progress shipment-stepper__progress--desktop"
    [class.shipment-stepper__progress--complete-active-step]="completeActiveStep()"
    [attr.aria-label]="'createShipment.stepper.progressAria' | translate"
  >
    @if (stepNavigationEnabled()) {
      <puro-progress-bar
        variant="desktop"
        [steps]="progressSteps()"
        [activeStep]="activeStepIndex()"
        (stepClick)="onStepClick($event)"
      />
    } @else {
      <puro-progress-bar
        variant="desktop"
        [steps]="progressSteps()"
        [activeStep]="activeStepIndex()"
      />
    }
  </nav>

  <nav
    class="shipment-stepper__mobile"
    [attr.aria-label]="'createShipment.stepper.progressAria' | translate"
  >
    <div class="shipment-stepper__mobile-header">
      <puro-typography variant="body1">
        {{ mobileStepLabel() }}
      </puro-typography>
      <puro-typography class="shipment-stepper__mobile-progress" variant="caption">
        {{
          'createShipment.stepper.mobileProgress'
            | translate: { current: mobileProgressCurrent(), total: mobileProgressTotal() }
        }}
      </puro-typography>
    </div>

    <puro-progress-bar
      class="shipment-stepper__progress shipment-stepper__progress--mobile"
      [class.shipment-stepper__progress--complete-active-step]="completeActiveStep()"
      variant="mobile"
      [steps]="progressSteps()"
      [activeStep]="activeStepIndex()"
      aria-hidden="true"
    />
  </nav>
</div>
